import React from "react";
import { Download, Filter as FilterIcon } from "lucide-react";

import { CustomersReportController } from "../../../../services/controllers/reports";
import { useCustomersReport } from "../../../../store/reports/useCustomersReport";

import { Filter } from "../../../../components/ui/Filter";
import { CAMPO } from "../../../../components/ui/Filter/sizes";
import { Input } from "../../../../components/ui/Form/Input";
import { Select } from "../../../../components/ui/Form/Select";

export function CustomersReportFilter() {
  const CCustomersReport = CustomersReportController();

  const filter = useCustomersReport((st) => st.data.filter);
  const isLoading = useCustomersReport((st) => st.data.isLoading);
  const total = useCustomersReport((st) => st.data.pagination.totalDocuments);

  return (
    <Filter.Root onSubmit={CCustomersReport.filterCustomers}>
      <Filter.Container>
        <Select.Root
          label="Tem pacote"
          style={CAMPO.medio}
          value={filter.hasPackage}
          onChange={(hasPackage) => CCustomersReport.setFilter({ hasPackage })}
        >
          <Select.Option value="*">Todos</Select.Option>
          <Select.Option value="true">Sim</Select.Option>
          <Select.Option value="false">Não</Select.Option>
        </Select.Root>

        <Select.Root
          label="Ausência"
          style={CAMPO.medio}
          value={filter.minAbsenceDays}
          onChange={(minAbsenceDays) => CCustomersReport.setFilter({ minAbsenceDays })}
        >
          <Select.Option value="7">7d</Select.Option>
          <Select.Option value="15">15d</Select.Option>
          <Select.Option value="30">30d</Select.Option>
          <Select.Option value="45">45d</Select.Option>
          <Select.Option value="60">60d</Select.Option>
          <Select.Option value="90">90d</Select.Option>
        </Select.Root>

        <Input.Root
          label="CPF"
          mask="999.999.999-99"
          style={CAMPO.medio}
          value={filter.cpf}
          onChange={(cpf) => CCustomersReport.setFilter({ cpf })}
        />

        <Input.Root
          label="Cliente ou pet"
          placeholder="Nome completo ou parte dele"
          style={CAMPO.busca}
          value={filter.search}
          onChange={(search) => CCustomersReport.setFilter({ search })}
        />
      </Filter.Container>

      <Filter.Actions>
        <Filter.Action isLoading={isLoading}>
          <Filter.ActionIcon icon={FilterIcon} isLoading={isLoading} />
          Filtrar
        </Filter.Action>

        <Filter.Action
          outline
          type="button"
          name="clear-customers-report"
          disabled={isLoading}
          onClick={CCustomersReport.clearFilter}
        >
          Limpar
        </Filter.Action>

        <Filter.Action
          outline
          type="button"
          name="export-customers-report"
          title="Exportar para Excel"
          disabled={isLoading || !total}
          onClick={CCustomersReport.reportExport}
        >
          <Filter.ActionIcon icon={Download} />
        </Filter.Action>
      </Filter.Actions>
    </Filter.Root>
  );
}
